/* eslint-disable padding-line-between-statements */
import { Button, useModal } from '@jutro/components';
import React, { useContext, useCallback, useEffect, useState } from 'react'
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import TWIAHoConstructionUtil from '../../../../twia-capability-quoteandbind-TWIAResidential-react/util/TWIAHoConstructionUtil';
import metadata from './TFPAAdditionalDetails.metadata.json5';
import messages from './TFPAAdditionalDetails.messages'



function TFPAAdditionalDetails(props) {
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate } = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const[showBuildingCodeClass, setShowBuildingCodeClass] = useState(false);
    const[showBuildingCode, setShowBuildingCode] = useState(false);
    
    const[buildingCodeClassAvailableValues, setBuildingCodeClassAvailableValues] = useState([]);
    const[buildingCodeAvailableValues, setBuildingCodeAvailableValues] = useState([]);
    const [yearMismatchValidationMessage, setYearMismatchValidationMessage] = useState([]);
    const [futureYearValidationMessage, setFutureYearValidationMessage] = useState([]);
    const [historicStructureAvilable, setHistoricStructureAvailable] = useState(false)
    const constructionDate= _.get(submissionVM,'lobData.homeowners.coverables_Ext.construction.originalConstDate_TWIA.value')

    const { refreshData } = useDataRefresh();
    const structureType = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.yourHome.structureType_TWIA.value')
    const historicStructure = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasQualifyForHistStruct_TWIA');
    const isGlazedRetrofitVisible = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.aspects.visible');
    const propertyEligibility = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasSB1702EligibilityException_TWIA');
    const isWPI8CertificateVisible = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasWPI8CertOfCompIssued_TWIA.aspects.visible');
    const yearBuilt = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.yearBuilt.value');
    const policyTypeCode = _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code');
    const MIN_YEARS_QUALIFY_HISTORIC_STRUCTURE = 49;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('TFPAAdditionalDetails');
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TFPAAdditionalDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'TFPAAdditionalDetails');
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        // DE15498
        _.set(submissionVM, 'lobData.homeowners.coverables_Ext.construction.structureType_TWIA.value', structureType);
        if (_.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === 'TWRM') {
            setShowBuildingCodeClass(false);
        }
        if (_.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.allRequiredFieldsValidation_TWIA.value') === undefined) {
            _.set(submissionVM, 'lobData.homeowners.coverables_Ext.construction.allRequiredFieldsValidation_TWIA.value', true);
        }
        updateWizardData(submissionVM)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (historicStructure && historicStructure.value === undefined && historicStructure.aspects.visible) {
            historicStructure.value = false
        }
        if (propertyEligibility && propertyEligibility.value === undefined && propertyEligibility.aspects.visible) {
            propertyEligibility.value = false
        }
        if (isGlazedRetrofitVisible && _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.value') === undefined) {
            _.set(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.value', false);
        }
        setYearMismatchValidationMessage([]);
        if (yearBuilt !== undefined && constructionDate !== undefined && constructionDate.year !== parseInt(yearBuilt)) {
            setYearMismatchValidationMessage([translator(messages.yearMustmatch)])
        }
        setFutureYearValidationMessage([]);
        const currentYear = (new Date()).getFullYear();
        if (!_.isUndefined(constructionDate)){
            if (constructionDate.year > (currentYear)){
                setFutureYearValidationMessage([translator(messages.cannotBeFutureDate)])
            }
        }
        
        // setHistoricStructureVisibility();
        updateWizardData(submissionVM)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isGlazedRetrofitVisible, historicStructure, yearBuilt])

    useEffect(() => {
        filterBuildingCodeClassesTWIA()
        filterBuildingCodesTWIA()
    }, [])
        

    const writeValue = useCallback((value, path) => {
        _.set(submissionVM, path, value);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const filterBuildingCodeClassesTWIA = useCallback(() => {

        const hasWPI8Issued = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasWPI8CertOfCompIssued_TWIA.value');
        const hasRetrofitIssued = _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasCertificateOfComplianceGlazedRetrofit_TWIA.value');
        const availableBuildingCodeClasses = submissionVM.lobData.homeowners.coverables_Ext.construction.buildingCodeClass_TWIA?.aspects.availableValues;

        TWIAHoConstructionUtil.filterBuildingCodeClassesTWIA(
            availableBuildingCodeClasses,
            _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.originalConstDate_TWIA.value'),
            hasWPI8Issued === true, hasRetrofitIssued === true

        );

        setShowBuildingCodeClass(false)
        setBuildingCodeClassAvailableValues([])

        if (availableBuildingCodeClasses.length > 0) {
            const buildingCodeClassList = availableBuildingCodeClasses.map((code) => {
                return {
                    code: code.code,
                    name: translator({ id: code.name })
                }
            })
            setShowBuildingCodeClass(true)
            setBuildingCodeClassAvailableValues(buildingCodeClassList)
        }
    }, [submissionVM, translator])

    const filterBuildingCodesTWIA = useCallback(() => {

        const availableBuildingCodes = submissionVM.lobData.homeowners.coverables_Ext.construction.buildingCode_TWIA?.aspects.availableValues;

        TWIAHoConstructionUtil.filterBuildingCodesTWIA(
            availableBuildingCodes,
            _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.buildingCodeClass_TWIA.value'),
            _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.originalConstDate_TWIA.value'),
        );

        setShowBuildingCode(false)
        setBuildingCodeAvailableValues([])

        if (availableBuildingCodes.length > 0) {
            const buildingCodeList = availableBuildingCodes.map((code) => {
                return {
                    code: code.code,
                    name: translator({ id: code.name })
                }

            })
            setShowBuildingCode(true)
            setBuildingCodeAvailableValues(buildingCodeList)
        }
    }, [submissionVM, translator])

    const setHistoricStructureVisibility = useCallback(() => {

        const minimumYear = new Date().getFullYear() - MIN_YEARS_QUALIFY_HISTORIC_STRUCTURE
        const yearBuild = parseInt(yearBuilt)
        const structureTypeCode = structureType.code;
        setHistoricStructureAvailable(false)

        switch (policyTypeCode) {
            case 'TWRD':
                if ((structureTypeCode === 'DwellingOutBuild' || structureTypeCode === '1Family' || structureTypeCode === '2Family'
                    || structureTypeCode === 'IndividuallyTH' || structureTypeCode === 'PublicHousing')
                    && yearBuild < minimumYear) {
                    setHistoricStructureAvailable(true)
                }
                break;
            case 'TWRP':
                if (yearBuild < minimumYear) {
                    setHistoricStructureAvailable(true)
                }
                break;
            case 'TWRC':
                if (yearBuild < minimumYear) {
                    setHistoricStructureAvailable(true)
                }
                break;
            case 'TWRM':
                setHistoricStructureAvailable(false)
                break;
            default:
        }

    }, [yearBuilt])

    const buildingCodeClassChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            filterBuildingCodesTWIA()
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, filterBuildingCodesTWIA]);

    const handleValueChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            if (_.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') !== 'TWRM') {
                filterBuildingCodeClassesTWIA()
            }
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, filterBuildingCodeClassesTWIA]);

    const constructionDateChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            _.set(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasWPI8CertOfCompIssued_TWIA.value', undefined);
            if (_.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') !== 'TWRM') {
                filterBuildingCodeClassesTWIA()
            }
            setYearMismatchValidationMessage([]);

            if (yearBuilt !== undefined && value !== undefined && value.year !== parseInt(yearBuilt)) {
                setYearMismatchValidationMessage([translator(messages.yearMustmatch)])
            }
            const currentYear = (new Date()).getFullYear();
            if (value.year > (currentYear)){
                setFutureYearValidationMessage([translator(messages.cannotBeFutureDate)])
            }
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, yearBuilt, translator, filterBuildingCodeClassesTWIA]);

    const resetBuildingCodeDetails = useCallback(() => {

        if (constructionDate === undefined || constructionDate === "") {
            _.set(submissionVM, 'lobData.homeowners.coverables_Ext.construction.buildingCodeClass_TWIA.value', undefined);
            _.set(submissionVM, 'lobData.homeowners.coverables_Ext.construction.buildingCode_TWIA.value', undefined);
            setShowBuildingCode(false)
            setShowBuildingCodeClass(false)
            updateWizardData(submissionVM);
            refreshData();
        }
    });

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true,
            readOnly: true
        },
        buildingCodeClass: {
            visible: constructionDate !== undefined && showBuildingCodeClass && _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.buildingCodeClass_TWIA.aspects.visible'),
            required: _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.buildingCodeClass_TWIA.aspects.required'),
        
        },
        buildingCode: {
            visible: constructionDate !== undefined && showBuildingCodeClass && showBuildingCode && _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.buildingCode_TWIA.aspects.visible'),
            required: _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.buildingCode_TWIA.aspects.required'),
        },
        constructionDate: {
            label: _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') === 'TWRM' ? messages.addedLivingSpConDate : messages.orgConstructionDate,
           // DE15510
            required: _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code') !== 'TWRM',
            validationMessages: !_.isEmpty(yearMismatchValidationMessage) && !_.isEmpty(futureYearValidationMessage) ? yearMismatchValidationMessage.concat( '\n', futureYearValidationMessage) :
                (!_.isEmpty(yearMismatchValidationMessage) ? yearMismatchValidationMessage: futureYearValidationMessage)
        },
        historicStructureException: {
            visible: historicStructureAvilable,
            required: _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasQualifyForHistStruct_TWIA.aspects.visible'),
            showRequired: true
        },
        WPI8Certificate: {
            required:  _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasWPI8CertOfCompIssued_TWIA.aspects.visible'),
            showRequired: true
        },
        moreInfoContainer: {
            visible: _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasSB1702EligibilityException_TWIA.aspects.visible'),
        },
        propertyEligibilityException: {
            visible: _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasSB1702EligibilityException_TWIA.aspects.visible'),
            required: _.get(submissionVM, 'lobData.homeowners.coverables_Ext.construction.hasSB1702EligibilityException_TWIA.aspects.visible'),
            showRequired: true  
        },
        certificateOfComplianceRetrofit: {
            visible: isGlazedRetrofitVisible,
            required: isGlazedRetrofitVisible,
            showRequired: isGlazedRetrofitVisible
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            OnBuildingCodeClassChange: buildingCodeClassChange,
            OnHandleValueChange: handleValueChange,
            onResetBuildingCodeDetails: resetBuildingCodeDetails,
            OnConstructionDateChange: constructionDateChange,
            
        },
        // resolveClassNameMap: styles
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent} 
            overrideProps={overrideProps}
            model={submissionVM}
            onModelChange={updateWizardData}
            showErrors={showErrors}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={setComponentValidation}
        />
    )
}

export default TFPAAdditionalDetails